import {
  ApiUtility,
  IApiListResult,
  IApiResponse,
} from "../../Utilities/ApiUtility.axios";
import { IIdNameModel, ItemAdd_Type } from "./ItemsService";
import { IGstShort } from "./SettingService";
import {
  IFileNameModel,
  ITCEligibility_Type,
  Voucher_Type,
} from "./VoucherServices";

export interface IFAItem {
  id?: string;
  name: string;
  number?: string;
  group: string;
  departmentId?: string;
  empId?: string;
  category?: string;
  location?: string;
  warranty?: string | any;
  assetModel?: string;
  identityCode?: string;
  assetOption?: string;
  assetVariant?: string;
  description?: string;
  purPrice?: number;
  taxRate?: IGstShort | any;
  hsnCode?: string;
  taxCredit?: ITCEligibility_Type;
  attachments?: IFileNameModel[];
  deleteUploadId?: string[];
  status?: AssetStatus_New;
  itemAddType?: ItemAdd_Type;
  isDepreciable: boolean;
  gstCategory?: string;
  depMethod?: CalcMethod;
  depRate?: number;
  lifeCycleDuration?: number;
  residualValue?: number;
  openingDetails?: IAssetOpeningDetail[];
}
export interface IAssetOpeningDetail {
  invNumber?: string;
  purchaseDate?: string | any;
  openingPurchasePrice?: number;
  openingQty?: number;
  accumulatedDepreciation?: number;
  wdValue?: number;
  wdvDate?: string | any;
  invRef?: string;
  itemDetail?: IInvAssetItemDetail;
}
export interface IInvAssetItemDetail {
  residualValue?: number;
  warranty?: string | any;
  identityCode?: string;
  depreciationStartDate?: string | any;
  location?: string;
  locationName?: string;
  empId?: string;
  empName?: string;
}
export interface IFAListResponse {
  key?: number | string;
  sno: number;
  id: string;
  number: string;
  isDepreciable: boolean;
  name: string;
  purPrice?: number;
  taxRate?: number;
  assetLocation?: string;
  depMethod?: CalcMethod;
  depRate?: number;
  lifeCycleDuration?: number;
  isAssetDisposed?: boolean;
  status?: AssetStatus_New;
  groupName?: string;
  groupId?: string;
  categoryName?: string;
  categoryId?: string;
  itemAddType: ItemAdd_Type;
}

export interface IChildAssetsListResponse {
  id: string;
  key?: number | string;
  sno: number;
  assetRef: IIdNameModel;
  date: string;
  adjust: FAAdjust_Type;
  itemDetail: IInvAssetItemDetail;
  qty: number;
  returnedQty: number;
  soldQty: number;
  availableQty: number;
  price: number;
  status: AssetStatus_New;
  voucherRef: IIdNameModel;
  category: string;
  categoryName: string;
  assetModel: string;
  assetOption: string;
  assetVariant: string;
  isDepreciable: boolean;
  depAmount: number;
  depMethod: CalcMethod;
  depRate: number;
  lifeCycleDuration: number;
}

export enum CalcMethod {
  WrittenDownValue,
  StraightLine,
}

export enum AssetPurType {
  NewPurchase,
  OldPurchase,
  All,
}
export enum PmtMethod {
  bank,
  cash,
  fullCredit,
  partialCredit,
}

export enum AssetStatus_New {
  All,
  Active,
  Inactive,
  Disposed,
  Deleted,
}

export enum Asset_Type {
  Single,
  Collective,
  All,
}
export enum FAAdjust_Type {
  Add = 1,
  Reduce = 2,
  OpeningStock = 3,
  Transfer = 4,
}
// export enum AssetPurchase_Type {
//   NewPurchase,
//   OldPurchase,
//   All,
// }

export const appendObjectToFormData = (
  formData: any,
  obj: any,
  parentKey = ""
) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const propKey = parentKey ? `${parentKey}[${key}]` : key;
      if (typeof obj[key] === "object" && obj[key] !== null) {
        appendObjectToFormData(formData, obj[key], propKey);
      } else {
        formData.append(propKey, obj[key]);
      }
    }
  }
};

class FixedAssetsServiceNew {
  route = `V1/API/Billing/Acc_New_FixedAsset`;

  // Get Initial data and edit by id
  getFixedAsset = (companyId: string, id?: string, isDisposed?: boolean) =>
    ApiUtility.get(
      `${this.route}/${companyId}/?${
        id ? `id=${id}&` : ""
      }isDisposed=${isDisposed}`
    );

  getAssetMaxNo = (
    companyId: string,
    voucherDate?: string
    // VoucherTitle?: string
  ) =>
    ApiUtility.get(
      `${this.route}/${companyId}/GetAssetMaxNo/?voucherDate=${voucherDate}`,
      {}
    );

  // ApiUtility.get(
  //   `${this.route}/${companyId}/GetAssetMaxNo/?voucherDate=${voucherDate}`,
  //   {
  //     VoucherTitle,
  //   }
  // );

  getAssetDetails = (companyId: string, id: string) =>
    ApiUtility.get<IApiResponse<IFAItem>>(
      `${this.route}/${companyId}?id=${id}`
    );

  // getParentAssetsList = (companyId: string) =>
  //   ApiUtility.get(`${this.route}/${companyId}/GetParentAssetsList`);

  PostFixedAssets = (companyId: string, params: IFAItem, id?: string) =>
    ApiUtility.postForm<IApiResponse<IIdNameModel>>(
      `${this.route}/${companyId}${id ? "/" + id : ""}`,
      params
    );

  PostDepreciationEntry = (
    companyId: string,
    voucherDate: string,
    params: IChildAssetsListResponse[]
  ) =>
    ApiUtility.post<IApiResponse<IIdNameModel>>(
      `${this.route}/${companyId}/DepreciationEntry?voucherDate=${voucherDate}`,
      params
    );

  postAsssetVoucher = (
    companyId: string | undefined,
    voucherType: Voucher_Type | undefined,
    params: any,
    id?: string
    // attachments?: any,
    // config?: string,
  ) =>
    ApiUtility.postForm(
      `${this.route}/${companyId}/SaveAssetVoucher${
        id ? "/" + id : ""
      }?voucherType=${voucherType}`,
      params
      // config,
      // attachments,
    );

  // getChildAssetList = (
  //   companyId: string | undefined,
  //   from: string,
  //   to: string,
  //   start: number,
  //   length: number,
  //   sortCol?: any,
  //   sortDir?: string,
  //   search?: string,
  //   type?: Asset_Type,
  //   status?: any,
  // ) =>
  //   ApiUtility.getResult(`${this.route}/${companyId}/GetChildAssetList`, {
  //     from,
  //     to,
  //     start,
  //     length,
  //     sortCol,
  //     sortDir,
  //     search,
  //     type,
  //     status,
  //   });

  getFixedAssetsList = (
    companyId: string,
    start: number,
    length: number,
    sortCol?: any,
    sortDir?: string,
    search?: string,
    status?: AssetStatus_New,
    type?: ItemAdd_Type,
    requestModel?: any
  ) =>
    ApiUtility.get<IApiResponse<IApiListResult<IFAListResponse>>>(
      `${this.route}/${companyId}/GetList`,
      {
        start,
        length,
        sortCol,
        sortDir,
        search,
        status,
        type,
        requestModel
      }
    );

  getChildAssetsList = (
    companyId: string,
    start: number,
    length: number,
    sortCol?: any,
    sortDir?: string,
    search?: string,
    status?: AssetStatus_New,
    type?: ItemAdd_Type,
    assetItemId?: string,
    tillDate?: string
  ) =>
    ApiUtility.get<IApiResponse<IApiListResult<IChildAssetsListResponse>>>(
      `${this.route}/${companyId}/GetChildAssetsList`,
      {
        start,
        length,
        sortCol,
        sortDir,
        search,
        status,
        type,
        assetItemId,
        tillDate,
      }
    );

  // https: //localhost:7142/V1/API/Billing/Acc_New_FixedAsset/686cfd16c80f8fe255a689d1/GetAssetItems?sortDir=desc

  getAssetsItemList = (
    companyId: string,
    sortCol?: string ,
    sortDir?: string ,
    search?: string,
    status?: AssetStatus_New,
    voucherType?: Voucher_Type
  ) =>
    ApiUtility.getResult(`${this.route}/${companyId}/GetAssetItems`, {
      sortCol,
      sortDir,
      search,
      status,
      voucherType,
    });

  // searchAsset = (clientId: string, term?: string, length?: number) =>
  //   ApiUtility.get(`${this.route}/${clientId}/SearchAsset`, { term, length });

  postDispose = (companyId: string, params: any) =>
    ApiUtility.post(`${this.route}/${companyId}/Disposalentry`, params);

  // reActivateAsset = (clientId: string, id: string) =>
  //   ApiUtility.post(
  //     `${this.route}/${clientId}/${id}/Activate`,
  //     id
  //   );
}
export default new FixedAssetsServiceNew();
